












































































































































































































































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from "vue-property-decorator";

//@ts-ignore
import departamentos from "@/mixins/axios/general_departamentos";

//@ts-ignore
import pmd_arboles_problema from "@/mixins/axios/pmd_arboles_problema";

//@ts-ignore
import dependencias from "@/mixins/axios/general_secretarias";

//@ts-ignore
import departamentos from "@/mixins/axios/general_departamentos";

//@ts-ignore
import TablePPoa from "@/components/tables/tablev1";
//@ts-ignore
import { email, required } from "vuelidate/lib/validators";
//@ts-ignore
import axios from "axios";
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";

@Component({
  components: {
    OrganizationChart,
  },

  data() {
    return {
      fullcard: false,
      type: "Creacion",

      dependencias: [],
      departamentos: [],
      problema: "",
      iddepartamento: 0,
      idsecretaria: 0,
      identificador: null,

      saveeditefecto: {
        data: { text: "" },
        type: null,
        i1: 0,
      },
      saveeditcausa: {
        data: { text: "" },
        type: null,
        i1: 0,
        i2: 0,
        i3: 0,
      },

      causas_n: [],
      efectos_n1: [],
      efectos_n2: [],
      efectos_n3: [],
      causas: [
        {
          id: "2",
          name: "Bo Miao",
          title: "department manager",
          children: [],
          type: 2,
        },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
      ],
      efectos: [
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
        { id: "2", name: "Bo Miao", title: "department manager", children: [] },
      ],
      ds: {
        id: "1",
        descripcion: "Problema centraal",
        title: "general manager",
        type: 1,
        children: [
          {
            id: "2",
            descripcion: "causa",
            title: "department manager",
            type: 2,
            children: [],
          },
          {
            id: "4",
            descripcion: "efecto",
            title: "department manager",
            type: 2,
            children: [],
          },

          {
            id: "3",
            descripcion: "causa",
            title: "department manager",
            type: 2,
            children: [
              {
                id: "4",
                descripcion: "hijo causa",
                title: "senior engineer",
                type: 0,
                children: [],
              },
            ],
          },
        ],
      },
    };
  },
  mixins: [pmd_arboles_problema, departamentos, dependencias],
  methods: {
    async onClick() {
       var sTable = document.getElementById('tablaproblema').innerHTML;
              await axios({
                    url: this.$store.state.baseapi+"pdf",
                    method: 'POST',
                    data:{
                      html:sTable,
                      titulo:"Arbol de Problemas",
                     id:this.$store.state.user.usuario.id_municipio
                    },
                    
          headers: { 
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
                    responseType: 'blob'
                }).then((response) => {
                     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                     var fileLink = document.createElement('a');

                     fileLink.href = fileURL;
                     fileLink.setAttribute('download', 'file.pdf');
                     document.body.appendChild(fileLink);

                     fileLink.click();
                });
          },
    async imprimir() {
      this.$router.push("/mun/poa/imprimirProblem");
    },
    onChange(event) {
      //console.log(event.target.value)
      this.getDataDepartamentos(event.target.value);
    },
    async getData() {
      this.$root.$emit("loading", true);
      console.log("loaddding");

      let data2 = {
        idmunicipio: this.$store.state.user.usuario.id_municipio,
        //   idsecretaria:this.$store.state.secretaria_sel.id,
        // iddepartamento:this.$store.state.departamento_sel.id,
      };

      let data = await this.GET_PMD_ARBOLES(data2).then((response) => {
        if (response != null) {
          //this.plantas = response;

          this.arbol_data = response;
        } else {
          //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
          console.log("ocurrio un error");
        }
        this.$root.$emit("loading", false);

        //loading.close();
      });
    },
    async getArbol() {
      this.$root.$emit("loading", true);
      console.log("loaddding");
      let data2 = {
        id: this.$store.state.arbol_problema.id,
      };

      let data = await this.GET_PMDID_ARBOLES(data2).then((response) => {
        if (response != null) {
          //this.plantas = response;
          //this.problema_select=response;
          this.idsecretaria = response.idsecretaria;
          this.getDataDepartamentos(this.idsecretaria);
          this.iddepartamento = response.iddepartamento;
          this.identificador = response.identificacion;
          this.efectos_n1 = JSON.parse(response.efectos)[0];
          this.efectos_n2 = JSON.parse(response.efectos)[1];
          this.efectos_n3 = JSON.parse(response.efectos)[2];
          this.causas_n = JSON.parse(response.causas);
          this.problema = response.problema;
          //console.log(response)
        } else {
          //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
          console.log("ocurrio un error");
        }
        this.$root.$emit("loading", false);

        //loading.close();
      });
    },

    async getDataDepartamentos(id) {
      this.$root.$emit("loading", true);
      console.log("muestra dep");

      let data2 = {
        iddependencia: id,
        idmunicipio: this.$store.state.user.usuario.id_municipio,
      };

      let data = await this.GET_GENERAL_DEPARTAMENTOS(data2).then(
        (response) => {
          if (response != null) {
            //this.plantas = response;

            this.departamentos = response;
          } else {
            //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
            console.log("ocurrio un error");
          }
          this.$root.$emit("loading", false);
          console.log("oculta dep");
          //loading.close();
        }
      );
    },
    async getDataSecretarias() {
      this.$root.$emit("loading", true);

      //this.$store.commit('SETLOADING',true);
      console.log("muestra sec");

      let data2 = {
        idmunicipio: this.$store.state.user.usuario.id_municipio,
      };

      let data = await this.GET_SECRETARIAS(data2).then((response) => {
        if (response != null) {
          //this.plantas = response;

          this.dependencias = response;
          //this.$root.$emit('loading', false);

          //this.$store.commit('SETLOADING',false);
          this.getDataDepartamentos(response[0].id);
        } else {
          //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
          console.log("ocurrio un error");
          this.$root.$emit("loading", false);
        }

        console.log("oculta sec");
        //loading.close();
      });
    },

    async create() {
      this.$root.$emit("loading", true);
      if ("edit" == this.$route.query.type) {
        let dat = {
          id: this.$store.state.arbol_problema.id,
          idsecretaria: this.idsecretaria,

          iddepartamento: this.iddepartamento,
          identificacion: this.identificador,
          problema: this.problema,
          efectos: [this.efectos_n1, this.efectos_n2, this.efectos_n3],
          causas: this.causas_n,
        };

        let data = await this.EDITAR_PMD_ARBOLES_PROBLEMA(dat).then(
          (response) => {
            if (response != null) {
              //this.plantas = response;
              //this.$router.push('/mun/general/pmd/arbol')
            } else {
              this.$root.$emit(
                "alerta_show",
                "Ocurrio un error al intentar editar el arbol de problemas, refresque la pagina"
              );
            }
            this.$root.$emit("loading", false);
            //loading.close();
          }
        );
        return;
      } else {
        this.$root.$emit("loading", true);
        let dat = {
          idsecretaria: this.idsecretaria,

          iddepartamento: this.iddepartamento,
          identificacion: this.identificador,
          problema: this.problema,
          efectos: [this.efectos_n1, this.efectos_n2, this.efectos_n3],
          causas: this.causas_n,
        };

        let data = await this.CREAR_PMD_ARBOLES_PROBLEMA(dat).then(
          (response) => {
            if (response != null) {
              //this.plantas = response;

              this.$router.push("/mun/poa/arbol");
            } else {
              this.$root.$emit(
                "alerta_show",
                "Ocurrio un error al intentar crear arbol de problemas, refresque la pagina"
              );
            }
            this.$root.$emit("loading", false);
            //loading.close();
          }
        );
      }
    },
    //pmd_arboles_problema

    add_i(type, index: 0, index2: 0) {
      switch (type) {
        case "n1":
          this.efectos_n1.push({ text: "efecto" });
          break;
        case "n2":
          this.efectos_n2.push({ text: "efecto" });
          break;
        case "n3":
          this.efectos_n3.push({ text: "efecto" });
          break;
        case "c1":
          this.causas_n.push({ text: "causa", childs: [] });
          break;
        case "child_causa":
          this.causas_n[index].childs.push({ text: "causa", childs: [] });
          break;
        case "child_child_causa":
          this.causas_n[index].childs[index2].childs.push({ text: "causa" });
          break;

        default:
          break;
      }
    },
    editefectosave() {
      let i1 = this.saveeditefecto.i1;
      switch (this.saveeditefecto.type) {
        case "e1":
          this.efectos_n1[i1] = this.saveeditefecto.data;

          break;
        case "e2":
          this.efectos_n2[i1] = this.saveeditefecto.data;
          break;
        case "e3":
          this.efectos_n3[i1] = this.saveeditefecto.data;

          break;

        default:
          break;
      }
      this.saveeditefecto.data = { text: "" };
      $("#modalEfecto").modal("hide");
    },
    editcausasave() {
      let i1 = this.saveeditcausa.i1;
      let i2 = this.saveeditcausa.i2;
      let i3 = this.saveeditcausa.i3;
      switch (this.saveeditcausa.type) {
        case "c1":
          this.causas_n[i1] = this.saveeditcausa.data;

          break;
        case "c2":
          this.causas_n[i1].childs[i2] = this.saveeditcausa.data;
          break;
        case "c3":
          this.causas_n[i1].childs[i2].childs[i3] = this.saveeditcausa.data;

          break;

        default:
          break;
      }
      this.saveeditcausa.data = { text: "" };
      $("#modalCausa").modal("hide");
    },
    editefecto(type, data: any, i1: 0) {
      this.saveeditefecto.data = data;
      this.saveeditefecto.type = type;
      this.saveeditefecto.i1 = i1;

      $("#modalEfecto").modal("show");
    },
    editcausa(type, data: any, i1: 0, i2: 0, i3: 0) {
      this.saveeditcausa.data = data;
      this.saveeditcausa.type = type;
      this.saveeditcausa.i1 = i1;
      this.saveeditcausa.i2 = i2;
      this.saveeditcausa.i3 = i3;

      $("#modalCausa").modal("show");
    },
    delete_causa(type, i1: 0, i2: 0, i3: 0) {
      switch (type) {
        case "c1":
          this.causas_n = this.causas_n
            .slice(0, i1)
            .concat(this.causas_n.slice(i1 + 1, this.causas_n.length));

          break;
        case "c2":
          this.causas_n[i1].childs = this.causas_n[i1].childs
            .slice(0, i2)
            .concat(
              this.causas_n[i1].childs.slice(
                i2 + 1,
                this.causas_n[i1].childs.length
              )
            );

          break;
        case "c3":
          this.causas_n[i1].childs[i2].childs = this.causas_n[i1].childs[
            i2
          ].childs
            .slice(0, i3)
            .concat(
              this.causas_n[i1].childs[i2].childs.slice(
                i3 + 1,
                this.causas_n[i1].childs[i2].childs.length
              )
            );

          break;

        default:
          break;
      }
    },
    delete_efecto(nivel, i) {
      console.log(nivel);
      console.log(i);
      if (nivel == "n1") {
        console.log("n1--");
        this.efectos_n1 = this.efectos_n1
          .slice(0, i)
          .concat(this.efectos_n1.slice(i + 1, this.efectos_n1.length));
        console.log(this.efectos_n1);
        if (this.efectos_n1.length <= 0) {
          this.efectos_n2 = [];
          this.efectos_n3 = [];
        }
      }
      if (nivel == "n2") {
        console.log("n2--");
        this.efectos_n2 = this.efectos_n2
          .slice(0, i)
          .concat(this.efectos_n2.slice(i + 1, this.efectos_n2.length));
        if (this.efectos_n2.length <= 0) {
          this.efectos_n3 = [];
        }
      }
      if (nivel == "n3") {
        console.log("n3--");
        this.efectos_n3 = this.efectos_n3
          .slice(0, i)
          .concat(this.efectos_n3.slice(i + 1, this.efectos_n3.length));
      }
    },
    validacion() {
      //
    },
    add(data) {
      $("#modalCausa").modal("show");
      switch (data.type) {
        case 1:
          //alert('causa');
          break;
        case 2:
          //  alert('hijo efecto');
          break;
        case 3:
          //alert('hijo causa');
          break;
        case 4:
          break;

        default:
          break;
      }
    },
    hola(data) {
      console.log(data);
    },
  },
  mounted() {
    this.getDataSecretarias();
    if (this.$route.query.type == "edit") {
      this.type = "Edicion";
      //this.getPeoblema();
      this.getArbol();
    }
  },
})
export default class Home extends Vue {}
